if (!customElements.get('custom-swatch-french-dropdown')) {
    customElements.define(
        'custom-swatch-french-dropdown',
        class FrenchDropdown extends HTMLElement {
            constructor() {
                super();
                this.targetDropdown = document.getElementById('product-select-' + this.getAttribute('product-id') + this.getAttribute('section-id'));
                this.frenchDropdown = this.querySelector('#fr-product-size-variants');
                this.frenchDropdown.addEventListener('change', this.onChange.bind(this));
                this.availabilityStockMessageShow = this.getAttribute('data-availability-show');
                this.inStockMsg = this.getAttribute('data-availability-message');
                this.outStockMsg = this.getAttribute('data-unavailability-message');
            }

            onChange(event) {
                event.preventDefault();
                event.stopPropagation();
                this.targetDropdown.value = event.target.value;
                let selectedOption = event.target.options[event.target.selectedIndex];
                let dataInventoryQuantity = selectedOption.getAttribute('data-inventory-quantity');
                let dataTotalCount =  document.querySelector('[data-total-count]');
                if (dataTotalCount) {
                    dataTotalCount.innerHTML = dataInventoryQuantity;
                }

                this.targetDropdown.dispatchEvent(new Event("change", {
                    bubbles: !0,
                    cancelable: !0
                }));

                if (this.availabilityStockMessageShow) {
                    const stockMessageEl = document.getElementById('availability-stock-message');
                    if (this.availabilityStockMessageShow && dataInventoryQuantity > 0) {
                        stockMessageEl.textContent = this.inStockMsg;
                    } else {
                        stockMessageEl.textContent = this.outStockMsg;
                    }
                }

            }
        })
}